// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { lazyLoadKeyframes } from "@store/Themes/common/mixins/lazyload";
import { loadingDotsKeyFrames } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { siteBannersHeightVariable } from "@store/Framework/Common/Utilities/siteBanners";
import { stickyHeaderHeightVariable } from "@store/Framework/Common/Utilities/getStickyHeaderHeight";
/* Store Custom Code - End */

const globalStyle: Styleguide["globalStyle"] = {
    css: css`
        ${lazyLoadKeyframes()}
        ${loadingDotsKeyFrames()}

        /* -- Form ------------------------------------------------------------ */

        input,
        textarea {
            &::placeholder {
                color: ${getColor("placeholder")};
                opacity: 1;
            }

            &:disabled,
            &.disabled {
                &::placeholder {
                    color: ${getColor("placeholder.disabled")};
                }
            }
        }

        fieldset {
            width: 100%;
            padding: 0;
            margin: 0;
            border: 0;
        }

        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield !important;
        }
        /* stylelint-enable property-no-vendor-prefix */

        input:placeholder-shown::-webkit-search-cancel-button {
            display: none;
        }

        input:not(:placeholder-shown)::-webkit-search-cancel-button {
            padding: ${pxToRem(1)};
            margin: 0 ${pxToRem(14)};
            cursor: pointer;
        }

        /* -- Print ----------------------------------------------------------- */

        @media print {
            body {
                font-size: inherit !important;
            }

            h1 {
                font-size: 26px !important;
            }
        }

        /* Store Custom Code - Start */
        /* The header publishes its measured height inline on <html>, which overrides these defaults. */
        html {
            ${siteBannersHeightVariable}: 0px; /* Published by SiteBanners */
            ${stickyHeaderHeightVariable}: 0px;

            /* Until it is measured, a page with a sticky header assumes the theme header height. */
            &:has([data-sticky-header]) {
                ${stickyHeaderHeightVariable}: ${x => x.theme.design.header.height[0]};
            }

            /* Keeps native anchor jumps clear of the sticky header */
            scroll-padding-top: var(${stickyHeaderHeightVariable});
        }

        /* Changes the top margin for the first content "Block" in the page */
        main[class^="PageStyle-"] > [class^="Wrapper-"],
        main[class^="PageStyle-"] > [class^="LoadingOverlayStyle-"] > [class^="Wrapper-"] {
            > [class^="BlockContainer-"]:first-child,
            > [class^="StyledNav-"]:first-child + [class^="BlockContainer-"] {
                > [class^="BlockSpacer-"] {
                    margin-top: 0;
                }

                &::before {
                    content: "";
                    display: block;
                    margin-top: ${pxToRem(24)};
                }
            }
        }
        /* Store Custom Code - End */
    `,
};

export default globalStyle;
